import apiService from '../api/api.service';
import { logger } from '@utils/logger';

class FeedbackAdminService {
  async getAllFeedback(filters = {}) {
    try {
      const response = await apiService.get('/feedback/all', { params: filters });
      return response;
    } catch (error) {
      logger.error('Error fetching all feedback', error);
      throw error;
    }
  }

  async getFeedbackById(feedbackId) {
    try {
      const response = await apiService.get(`/feedback/${feedbackId}`);
      return response;
    } catch (error) {
      logger.error('Error fetching feedback details', error);
      throw error;
    }
  }

  async updateReview(feedbackId, reviewData) {
    try {
      const response = await apiService.put(`/feedback/${feedbackId}/review`, reviewData);
      return response;
    } catch (error) {
      logger.error('Error updating feedback review', error);
      throw error;
    }
  }

  async getStats() {
    try {
      const response = await apiService.get('/feedback/stats');
      return response;
    } catch (error) {
      logger.error('Error fetching feedback stats', error);
      throw error;
    }
  }

  async exportFeedback(filters = {}) {
    try {
      const response = await apiService.get('/feedback/export', { 
        params: filters,
        responseType: 'blob'
      });
      return response;
    } catch (error) {
      logger.error('Error exporting feedback', error);
      throw error;
    }
  }
}

export default new FeedbackAdminService();
